/* eslint-disable react/no-danger */
import React from 'react';

import { HowToRecycleBannerData } from './models';

import './HowToRecycleBanner.scss';

interface HowToRecycleBannerProps {
  data?: HowToRecycleBannerData;
}

const HowToRecycleBanner = ({ data }: HowToRecycleBannerProps) => {
  const {
    finishLogo,
    heading,
    icon1,
    icon2,
    icon3,
    bgImageMobile,
    bgImageDesktop,
    icon1Text,
    icon2Text,
    icon3Text,
  } = data || {};
  const icons = [
    { icon: icon1, text: icon1Text },
    { icon: icon2, text: icon2Text },
    { icon: icon3, text: icon3Text },
  ];

  return (
    <section
      className="how-to-recycle-banner"
      style={
        {
          '--bg-image-desktop': `url(${bgImageDesktop?.url ?? ''})`,
          '--bg-image-mobile': `url(${bgImageMobile?.url || bgImageDesktop?.url || ''})`,
        } as React.CSSProperties
      }
    >
      <div className="how-to-recycle-banner__content">
        {finishLogo && (
          <img
            className="how-to-recycle-banner__finish-logo"
            src={`${finishLogo.url}`}
            alt="Finish Logo"
          />
        )}
        {heading && <h2 className="how-to-recycle-banner__title">{heading}</h2>}

        <ul className="how-to-recycle-banner__icons-list">
          {icons.map(({ text, icon }) => (
            <li key={text} className="how-to-recycle-banner__icon-item">
              {icon && <img src={icon.url} alt={text} />}
              {text && <p>{text}</p>}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

HowToRecycleBanner.displayName = 'HowToRecycleBanner';
export default HowToRecycleBanner;
